import Vue from 'vue';
import {SERVERS_HOST_LIST} from "@/config";

export class ServerCommon {

  public static getUid(): Promise<any> {

    return new Promise((resolve, reject) => {

      Vue.axios({
        url: SERVERS_HOST_LIST[0]+'v1/auth/get-uid',
        method: 'GET',
      })
        .then((resp: any) => {
          resolve(resp.data.uid);
        })
        .catch((err: any) => {
          reject(err);
        });

    })

  }

}

